
import { IDevice } from '../../../interfaces/types.ts'
import { findDevice } from '../../../helpers/commandHelper.ts'

interface Props {
    device: IDevice | null | undefined
    disabled: boolean
}

export const FindButton = (props: Props) => {
    const { device, disabled } = props
    if (!device) return null
    const style = `btn btn-xs btn-secondary without-ring h-fit border-1 border-white w-[7rem] ${disabled ? 'bg-gray-400 text-white' : 'btn-secondary '}`
    
    return (
        <div className={''}>
            <button
                className={style}
                disabled={disabled}
                onClick={async () => {
                    if (!disabled && device) {
                        await findDevice(device)
                    }
                }}
            >
                Find
            </button>
        </div>
    )
}
